import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ChangePasswordCard() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (next.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current || null, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="border border-border p-8 space-y-4" data-testid="change-password-card">
      <div className="font-overline text-accent">Change Password</div>
      <p className="text-xs text-muted-foreground">
        Leave the current-password field blank if you signed up via Google or Magic Link and haven&apos;t set one yet.
      </p>
      <div>
        <Label className="font-overline">Current Password</Label>
        <Input type="password" className="rounded-none mt-2" value={current}
          onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" />
      </div>
      <div>
        <Label className="font-overline">New Password</Label>
        <Input type="password" className="rounded-none mt-2" value={next}
          onChange={(e) => setNext(e.target.value)} data-testid="cp-new" />
      </div>
      <div>
        <Label className="font-overline">Confirm New Password</Label>
        <Input type="password" className="rounded-none mt-2" value={confirm}
          onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" />
      </div>
      <Button onClick={submit} disabled={busy || !next || !confirm}
        className="rounded-none uppercase tracking-wider h-11" data-testid="cp-submit">
        {busy ? "Saving…" : "Update Password"}
      </Button>
    </div>
  );
}
